import { SubscribeForm } from "../../lib-api";
import React, { useState } from "react";
import { useFormik } from "formik";
import { object, string } from "yup";
import { Form, Button } from "react-bootstrap";
import { api } from "../../api";

enum SubmitState {
  None,
  Submitted,
  Error,
}

export const EmailSubscribeForm = (props: {
  location: string;
  onSubscribed?: () => void;
  hasAutofocus: boolean;
}) => {
  const [submitState, setSubmitState] = useState(SubmitState.None);

  const {
    values,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik<SubscribeForm>({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: object({
      email: string().required().email(),
      name: string().max(100),
    }),
    onSubmit: async (values) => {
      try {
        await api.subscribeToNewsletter(values, props.location);
        setSubmitState(SubmitState.Submitted);
        if (props.onSubscribed != null) {
          props.onSubscribed();
        }
      } catch (e) {
        setSubmitState(SubmitState.Error);
      }
    },
  });

  return (
    <div>
      {submitState != SubmitState.Submitted && (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formSubscribeEmail">
            <Form.Label srOnly={true}>Email</Form.Label>
            <Form.Control
              isInvalid={errors.email != null}
              name="email"
              type="email"
              placeholder="E-mail"
              value={values.email}
              disabled={isSubmitting}
              onChange={handleChange}
              autoFocus={props.hasAutofocus}
            />
          </Form.Group>
          <Button
            disabled={isSubmitting}
            variant="primary"
            block={true}
            type="submit"
          >
            Tilmeld
          </Button>
        </Form>
      )}
      {submitState == SubmitState.Error && (
        <div>
          Ups, der opstod en fejl.
          <br />
          <a className="text-primary" onClick={() => submitForm()}>
            Prøv igen...
          </a>
        </div>
      )}
      {submitState == SubmitState.Submitted && (
        <div>Tak for din tilmelding.</div>
      )}
    </div>
  );
};
